import { Button, Group, Stack, Text } from '@mantine/core'
import { IconHandStop, IconShieldX } from '@tabler/icons-react'

export default function AdBlockDetectedModal() {
  return (
    <>
      <Stack gap="md" align="center" p="sm">
        <Group align="center">
          <IconShieldX size={48} color="var(--mantine-color-red-7)" />
        </Group>

        <Text fw={700} size="xl">
          Wykryto blokadę reklam
        </Text>

        <Text size="md">
          Wygląda na to, że korzystasz z rozszerzenia blokującego reklamy. Aby móc korzystać z pełnej wersji naszej
          strony, prosimy o wyłączenie blokady reklam lub dodanie naszej domeny do wyjątków.
        </Text>
      </Stack>
      <Group grow px="sm" mt="md">
        <Button
          size="md"
          variant="light"
          leftSection={<IconHandStop size={18} />}
          onClick={() => window.location.reload()}
        >
          Wyłączyłem blokadę - odśwież stronę
        </Button>
      </Group>
    </>
  )
}
